export default __webpack_public_path__ + "static/media/EMprint Light.03a9e0e2.woff";